import React from "react";
import {ThemeProvider} from "@mui/material";
import {CustomProvider} from "rsuite";
import frFR from 'rsuite/locales/fr_FR';

import {themeOptions} from "./Config";
import {Header, Waves} from "./Components";
import {useAppStore} from "./Stores";
import {AppSelection} from "./AppSelection";
import {AppForm} from "./AppForm";

import 'rsuite/dist/rsuite.min.css';
import "./App.scss";

import 'rsuite/dist/rsuite.min.css';
export const App: React.FC = () => {
  const labelType = useAppStore.use.labelType();

  return (
    <CustomProvider theme="light" locale={frFR}>
      <ThemeProvider theme={themeOptions}>
        <>
          <div className="app-container">
            <Header />

            {!labelType ? <AppSelection/> : <AppForm/>}

            <Waves/>
          </div>

          <div className="footer flex">
            <p></p>
          </div>
        </>
      </ThemeProvider>
    </CustomProvider>
  );
}

export default App;
